var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.taskListTemplate && _vm.taskListTemplate.can_create_task_with_dependency)?_c('div',[_c('select-input',{attrs:{"name":"task_template_parent_id","options":_vm.taskTemplateAvailableParents,"placeholder":"Välj beroende"},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }